(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-parallax"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroParallax() {
      var sections = document.querySelectorAll('[data-hero-parallax]');
      if (!sections.length || !window.gsap) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

      sections.forEach(function (section) {
        var media = section.querySelector('[data-hero-parallax-media]');
        var content = section.querySelector('[data-hero-parallax-content]');

        // Entrance: content fades + rises in once, independent of scroll.
        if (content) {
          if (reduceMotion) {
            gsap.set(content, { opacity: 1 });
          } else {
            gsap.fromTo(
              content,
              { opacity: 0, y: 16 },
              { opacity: 1, y: 0, duration: 1, ease: 'power2.out', delay: 0.2 }
            );
          }
        }

        // Parallax drift: the image moves a small amount slower than the
        // page as the hero scrolls past — restrained (±6%), not a showy
        // zoom/mask effect. Skipped entirely under reduced motion.
        if (media && !reduceMotion && window.ScrollTrigger) {
          gsap.fromTo(
            media,
            { yPercent: -6 },
            {
              yPercent: 6,
              ease: 'none',
              scrollTrigger: {
                trigger: section,
                start: 'top top',
                end: 'bottom top',
                scrub: true
              }
            }
          );
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroParallax);
    } else {
      initHeroParallax();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifesto-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initManifesto() {
      var els = document.querySelectorAll('[data-manifesto-text]');
      if (!els.length || !window.gsap || !window.SplitText) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      gsap.registerPlugin(ScrollTrigger, SplitText);

      els.forEach(function (el) {
        if (reduceMotion) {
          // Reduced motion: show the text as-is, no split, no animation.
          el.style.opacity = '1';
          return;
        }

        var split = new SplitText(el, {
          type: 'lines',
          linesClass: 'manifesto-line'
        });

        // Wrap each line's content so the mask (overflow:hidden on the
        // line div) and the moving element (translateY) are separate —
        // required for a clean reveal-from-below without clipping glyphs.
        split.lines.forEach(function (line) {
          var inner = document.createElement('div');
          while (line.firstChild) inner.appendChild(line.firstChild);
          line.appendChild(inner);
          gsap.set(inner, { yPercent: 100, opacity: 0 });
        });

        gsap.to(
          split.lines.map(function (line) { return line.firstChild; }),
          {
            yPercent: 0,
            opacity: 1,
            duration: 0.9,
            ease: 'power3.out',
            stagger: 0.12,
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              once: true
            }
          }
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initManifesto);
    } else {
      initManifesto();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olfactory-talks-glass-carousel"] && !Shopify.designMode) return;
  try {
    
  class MzaCarousel {
    constructor(root, opts = {}) {
      this.root = root;
      this.viewport = root.querySelector('.mzaCarousel-viewport');
      this.track = root.querySelector('.mzaCarousel-track');
      this.slides = Array.from(root.querySelectorAll('.mzaCarousel-slide'));
      this.prevBtn = root.querySelector('.mzaCarousel-prev');
      this.nextBtn = root.querySelector('.mzaCarousel-next');
      this.pagination = root.querySelector('.mzaCarousel-pagination');
      this.progressBar = root.querySelector('.mzaCarousel-progressBar');
      this.isFF = typeof InstallTrigger !== 'undefined';
      this.n = this.slides.length;
      this.state = {
        index: 0, pos: 0, width: 0, height: 0, gap: 28,
        dragging: false, pointerId: null, x0: 0, v: 0, t0: 0,
        animating: false, hovering: false, startTime: 0, pausedAt: 0, rafId: 0
      };
      this.opts = Object.assign({
        gap: 20, peek: 0.15, rotateY: 18, zDepth: 70, scaleDrop: 0.09,
        blurMax: 2.0, activeLeftBias: 0.12, interval: 5200, transitionMs: 900,
        keyboard: true, minCardH: 320, maxCardH: 640,
        // Real structural note: .mzaCarousel-slide is `left: 50%` but the
        // transform below only ever applies translateX(tx), never -50% — so
        // the ACTIVE slide is only visually centered when activeLeftBias
        // happens to cancel it out (tx = -slideW/2 needs activeLeftBias =
        // 0.5 exactly, since weight=1 for the active card). Desktop's small
        // bias values (0.1–0.12) are an intentional stylistic left-lean on
        // top of a container that isn't full-bleed, and desktop is locked/
        // approved as-is — don't "fix" the transform globally, it will
        // shift the whole locked desktop layout. Mobile tiers below use
        // activeLeftBias: 0.5 specifically to get TRUE centering, since at
        // ~96vw width with near-zero peek there's no room for a stylistic
        // lean — real bug found via a mobile screenshot where the active
        // card bled off the right edge entirely once bias was set to 0.
        breakpoints: [
          { mq: '(max-width: 1200px)', gap: 18, peek: 0.12, rotateY: 15, zDepth: 60, scaleDrop: 0.08, activeLeftBias: 0.1 },
          { mq: '(max-width: 1000px)', gap: 14, peek: 0.09, rotateY: 12, zDepth: 45, scaleDrop: 0.07, activeLeftBias: 0.09 },
          { mq: '(max-width: 1024px)', gap: 16, peek: 0.02, rotateY: 16, zDepth: 70, scaleDrop: 0.4, activeLeftBias: 0.5 },
          { mq: '(max-width: 560px)', gap: 16, peek: 0.02, rotateY: 12, zDepth: 60, scaleDrop: 0.4, activeLeftBias: 0.5 }
        ]
      }, opts);
      if (this.isFF) { this.opts.rotateY = 10; this.opts.zDepth = 0; this.opts.blurMax = 0; }
      if (this.n) this._init();
    }
    _init() {
      try {
        this._setupDots();
        this._bind();
        this._preloadImages();
        this._measure();
        this.goTo(0, false);
        this._startCycle();
        this._loop();
      } catch (err) {
        this.root.style.minHeight = '260px';
      }
    }
    _preloadImages() {
      this.slides.forEach((sl) => {
        const card = sl.querySelector('.mzaCard');
        const bg = getComputedStyle(card).getPropertyValue('--mzaCard-bg');
        const m = /url\((?:'|")?([^'")]+)(?:'|")?\)/.exec(bg);
        if (m && m[1]) { const img = new Image(); img.src = m[1]; }
      });
    }
    _setupDots() {
      this.pagination.innerHTML = '';
      this.dots = this.slides.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'mzaCarousel-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => { this.goTo(i); });
        this.pagination.appendChild(b);
        return b;
      });
    }
    _bind() {
      this.prevBtn.addEventListener('click', () => { this.prev(); });
      this.nextBtn.addEventListener('click', () => { this.next(); });
      if (this.opts.keyboard) {
        this.root.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.prev();
          if (e.key === 'ArrowRight') this.next();
        });
      }
      const pe = this.viewport;
      pe.addEventListener('pointerdown', (e) => this._onDragStart(e));
      pe.addEventListener('pointermove', (e) => this._onDragMove(e));
      pe.addEventListener('pointerup', (e) => this._onDragEnd(e));
      pe.addEventListener('pointercancel', (e) => this._onDragEnd(e));
      this.root.addEventListener('mouseenter', () => {
        this.state.hovering = true;
        this.state.pausedAt = performance.now();
      });
      this.root.addEventListener('mouseleave', () => {
        if (this.state.pausedAt) {
          this.state.startTime += performance.now() - this.state.pausedAt;
          this.state.pausedAt = 0;
        }
        this.state.hovering = false;
      });
      this.ro = new ResizeObserver(() => this._measure());
      this.ro.observe(this.viewport);
      this.opts.breakpoints.forEach((bp) => {
        const m = window.matchMedia(bp.mq);
        const apply = () => {
          Object.keys(bp).forEach((k) => { if (k !== 'mq') this.opts[k] = bp[k]; });
          this._measure();
          this._render();
        };
        if (m.addEventListener) m.addEventListener('change', apply);
        else m.addListener(apply);
        if (m.matches) apply();
      });
      this.viewport.addEventListener('pointermove', (e) => this._onTilt(e));
      window.addEventListener('orientationchange', () => setTimeout(() => this._measure(), 250));
    }
    _measure() {
      // A real resize/breakpoint change means the fixed height's reference
      // width is stale — recompute once. Slide transitions never call
      // _measure(), only _syncHeight(), so the cache still holds steady
      // while cards move.
      this._fixedHeight = null;
      const viewRect = this.viewport.getBoundingClientRect();
      const rootRect = this.root.getBoundingClientRect();
      const pagRect = this.pagination.getBoundingClientRect();
      const bottomGap = Math.max(48, Math.round(rootRect.bottom - pagRect.bottom));
      const pagSpace = pagRect.height + bottomGap;
      const availH = viewRect.height - pagSpace;
      this.state.width = viewRect.width;
      this.state.height = viewRect.height;
      this.state.gap = this.opts.gap;
      // Real rendered width of an actual slide (CSS --mzaC-slideW, post-layout)
      // — not an independent peek-based estimate. Those two used to drift
      // apart across breakpoints and left a visible gap/overlap mismatch
      // between adjacent slides; reading the real box removes the class of
      // bug entirely instead of re-tuning two numbers to match by hand.
      // offsetWidth, not getBoundingClientRect — the latter returns the
      // POST-TRANSFORM (scaled) box, and slides[0] is usually not the
      // active slide, so it's usually mid-scale-down: using its rect width
      // silently under-measured slideW and under-spaced every card.
      const sampleSlide = this.slides[0];
      const realSlideW = sampleSlide ? sampleSlide.offsetWidth : 0;
      this.slideW = realSlideW || Math.min(880, this.state.width * (1 - this.opts.peek * 2));
      this.state.pagSpace = pagSpace;
      this.root.style.setProperty('--mzaPagH', pagSpace + 'px');
      this._syncHeight();
      this._syncMobileCaptionOffsets();
    }
    _syncMobileCaptionOffsets() {
      // Mobile's caption strip depends on the caption sitting exactly below
      // the real (uncropped) photo height — that offset was expressed as a
      // pure-CSS `margin-top: calc(var(--mzaC-slideW) / var(--mzaCard-ratio))`
      // on .mzaCard-text. In production that calc() reliably resolved to 0
      // (confirmed live: position:static from the same rule applied fine,
      // but margin-top did not) — real bug, cause not worth chasing further
      // since the fix is the same either way. Set the pixel value directly
      // from JS instead, inline, which can't silently fail the way the CSS
      // custom-property chain did. No-ops on desktop (extra stays 0).
      this.slides.forEach((el) => {
        const cs = getComputedStyle(el);
        const extra = parseFloat(cs.getPropertyValue('--otc-caption-extra')) || 0;
        const text = el.querySelector('.mzaCard-text');
        if (!text) return;
        if (extra > 0) {
          const ratio = parseFloat(cs.getPropertyValue('--mzaCard-ratio')) || 1;
          const w = el.offsetWidth;
          text.style.marginTop = (w / ratio) + 'px';
        } else {
          text.style.marginTop = '';
        }
      });
    }
    _slideNaturalHeight(idx) {
      // Computed purely from width / aspect-ratio — never read from the
      // slide's own rendered box. offsetWidth, not getBoundingClientRect:
      // the latter returns the POST-TRANSFORM (scaled) box, and a
      // non-active slide is usually mid-scale-down.
      const el = this.slides[idx];
      if (!el) return 0;
      const cs = getComputedStyle(el);
      const w = el.offsetWidth;
      const ratio = parseFloat(cs.getPropertyValue('--mzaCard-ratio')) || 1;
      const extra = parseFloat(cs.getPropertyValue('--otc-caption-extra')) || 0;
      if (!w || !ratio) return 0;
      return w / ratio + extra;
    }
    _syncHeight() {
      // Fixed height, computed once from a reference slide — deliberately
      // NOT tied to whichever slide is currently active. It used to blend
      // between outgoing/incoming heights during a transition, which made
      // the whole section visibly grow/shrink as cards slid past — real,
      // reported jank on both desktop and mobile. Real photos share one
      // consistent aspect ratio, so a fixed height never crops or
      // letterboxes any of them; only the cards move inside the section now.
      //
      // Mobile is the exception: its layout is built to show each photo's
      // real uncropped ratio with the caption below it (see the mobile
      // media query), so articles legitimately render at different heights
      // there. Freezing one card's height and reusing it for all of them
      // clipped taller/shorter cards against the carousel's overflow:hidden
      // box — the caption+button ended up visually sitting over the photo
      // instead of in the blank strip below it. Recompute per active slide
      // whenever the mobile caption strip is active (--otc-caption-extra >
      // 0); keep the frozen/cached value for desktop, where crop-to-fit
      // guarantees every card is the same height anyway.
      const idx = this._mod(Math.round(this.state.pos || this.state.index), this.n);
      const mobileCaption = this.slides[idx] &&
        parseFloat(getComputedStyle(this.slides[idx]).getPropertyValue('--otc-caption-extra')) > 0;
      if (mobileCaption) {
        this._fixedHeight = this._slideNaturalHeight(idx);
      } else if (this._fixedHeight == null) {
        this._fixedHeight = this._slideNaturalHeight(idx);
      }
      const h = Math.round(this._fixedHeight);
      if (h > 40) {
        this.root.style.height = (h + this.state.pagSpace + 64) + 'px';
      }
    }
    _onTilt(e) {
      const r = this.viewport.getBoundingClientRect();
      const mx = (e.clientX - r.left) / r.width - 0.5;
      const my = (e.clientY - r.top) / r.height - 0.5;
      this.root.style.setProperty('--mzaTiltX', (my * -6).toFixed(3));
      this.root.style.setProperty('--mzaTiltY', (mx * 6).toFixed(3));
    }
    _onDragStart(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      this.state.dragging = true;
      this.state.pointerId = e.pointerId;
      this.viewport.setPointerCapture(e.pointerId);
      this.state.x0 = e.clientX;
      this.state.t0 = performance.now();
      this.state.v = 0;
      this.state.pausedAt = performance.now();
    }
    _onDragMove(e) {
      if (!this.state.dragging || e.pointerId !== this.state.pointerId) return;
      const dx = e.clientX - this.state.x0;
      const dt = Math.max(16, performance.now() - this.state.t0);
      this.state.v = dx / dt;
      const slideSpan = this.slideW + this.state.gap;
      this.state.pos = this._mod(this.state.index - dx / slideSpan, this.n);
      this._render();
      this._syncHeight();
    }
    _onDragEnd(e) {
      if (!this.state.dragging || (e && e.pointerId !== this.state.pointerId)) return;
      this.state.dragging = false;
      try { if (this.state.pointerId != null) this.viewport.releasePointerCapture(this.state.pointerId); } catch (err) {}
      this.state.pointerId = null;
      if (this.state.pausedAt) {
        this.state.startTime += performance.now() - this.state.pausedAt;
        this.state.pausedAt = 0;
      }
      const v = this.state.v;
      const threshold = 0.18;
      let target = Math.round(this.state.pos - Math.sign(v) * (Math.abs(v) > threshold ? 0.5 : 0));
      this.goTo(this._mod(target, this.n));
    }
    _startCycle() {
      this.state.startTime = performance.now();
      this._renderProgress(0);
    }
    _loop() {
      const step = (t) => {
        if (!this.state.dragging && !this.state.hovering && !this.state.animating) {
          const elapsed = t - this.state.startTime;
          const p = Math.min(1, elapsed / this.opts.interval);
          this._renderProgress(p);
          if (elapsed >= this.opts.interval) this.next();
        }
        this.state.rafId = requestAnimationFrame(step);
      };
      this.state.rafId = requestAnimationFrame(step);
    }
    _renderProgress(p) { this.progressBar.style.transform = 'scaleX(' + p + ')'; }
    prev() { this.goTo(this._mod(this.state.index - 1, this.n)); }
    next() { this.goTo(this._mod(this.state.index + 1, this.n)); }
    goTo(i, animate = true) {
      const start = this.state.pos || this.state.index;
      const end = this._nearest(start, i);
      const dur = animate ? this.opts.transitionMs : 0;
      const t0 = performance.now();
      const ease = (x) => 1 - Math.pow(1 - x, 4);
      this.state.animating = true;
      const step = (now) => {
        const t = Math.min(1, (now - t0) / dur);
        const p = dur ? ease(t) : 1;
        this.state.pos = start + (end - start) * p;
        this._render();
        this._syncHeight();
        if (t < 1) requestAnimationFrame(step);
        else this._afterSnap(i);
      };
      requestAnimationFrame(step);
    }
    _afterSnap(i) {
      this.state.index = this._mod(Math.round(this.state.pos), this.n);
      this.state.pos = this.state.index;
      this.state.animating = false;
      this._render(true);
      this._syncHeight();
      this._startCycle();
    }
    _nearest(from, target) {
      let d = target - Math.round(from);
      if (d > this.n / 2) d -= this.n;
      if (d < -this.n / 2) d += this.n;
      return Math.round(from) + d;
    }
    _mod(i, n) { return ((i % n) + n) % n; }
    _render(markActive = false) {
      const span = this.slideW + this.state.gap;
      const tiltX = parseFloat(this.root.style.getPropertyValue('--mzaTiltX') || 0);
      const tiltY = parseFloat(this.root.style.getPropertyValue('--mzaTiltY') || 0);
      for (let i = 0; i < this.n; i++) {
        try {
          let d = i - this.state.pos;
          if (d > this.n / 2) d -= this.n;
          if (d < -this.n / 2) d += this.n;
          const weight = Math.max(0, 1 - Math.abs(d) * 2);
          const biasActive = -this.slideW * this.opts.activeLeftBias * weight;
          const tx = d * span + biasActive;
          const depth = -Math.abs(d) * this.opts.zDepth;
          const rot = -d * this.opts.rotateY;
          const scale = 1 - Math.min(Math.abs(d) * this.opts.scaleDrop, 0.42);
          const blur = Math.min(Math.abs(d) * this.opts.blurMax, this.opts.blurMax);
          const z = Math.round(1000 - Math.abs(d) * 10);
          const s = this.slides[i];
          if (this.isFF) {
            s.style.transform = 'translate(' + tx + 'px,-50%) scale(' + scale + ')';
            s.style.filter = 'none';
          } else {
            s.style.transform = 'translate3d(' + tx + 'px,-50%,' + depth + 'px) rotateY(' + rot + 'deg) scale(' + scale + ')';
            s.style.filter = 'blur(' + blur + 'px)';
          }
          s.style.zIndex = z;
          if (markActive) s.dataset.state = Math.round(this.state.index) === i ? 'active' : 'rest';
          const card = s.querySelector('.mzaCard');
          if (card) {
            const parBase = Math.max(-1, Math.min(1, -d));
            const parX = parBase * 48 + tiltY * 2.0;
            const parY = tiltX * -1.5;
            const bgX = parBase * -64 + tiltY * -2.4;
            card.style.setProperty('--mzaParX', parX.toFixed(2) + 'px');
            card.style.setProperty('--mzaParY', parY.toFixed(2) + 'px');
            card.style.setProperty('--mzaParBgX', bgX.toFixed(2) + 'px');
            card.style.setProperty('--mzaParBgY', (parY * 0.35).toFixed(2) + 'px');
          }
        } catch (err) {
          /* One bad slide must never blank the rest of the carousel — real
             production bug: an uncaught error here left every later slide
             at its default no-transform state (invisible/collapsed). */
        }
      }
      const active = this._mod(Math.round(this.state.pos), this.n);
      this.dots.forEach((d, i) => d.setAttribute('aria-selected', i === active ? 'true' : 'false'));
    }
  }

  document.querySelectorAll('.mzaCarousel').forEach((el) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      new MzaCarousel(el, { interval: 999999, transitionMs: 1 });
    } else {
      new MzaCarousel(el, { transitionMs: 900 });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPinnedStory() {
      var sections = document.querySelectorAll('[data-pinned-story]');
      if (!sections.length || !window.gsap || !window.ScrollTrigger) return;

      gsap.registerPlugin(ScrollTrigger);
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;

      sections.forEach(function (section) {
        var pinEl = section.querySelector('[data-pinned-story-pin]');
        var lines = section.querySelectorAll('[data-pinned-story-line]');

        // Pin the image panel for the height of the text column, desktop
        // only — on mobile the image sits inline above the text, no pin
        // (pinning a half-width column makes no sense in a stacked layout).
        if (pinEl && isDesktop && !reduceMotion) {
          ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: 'bottom bottom',
            pin: pinEl,
            pinSpacing: false
          });
        }

        // Text lines fade + rise in once as they individually enter view —
        // same restrained language as the manifesto/hero sections.
        lines.forEach(function (line) {
          if (reduceMotion) {
            gsap.set(line, { opacity: 1, y: 0 });
            return;
          }
          gsap.to(line, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: line,
              start: 'top 85%',
              once: true
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPinnedStory);
    } else {
      initPinnedStory();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
